import { StyledErrorContainer } from "./style";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

const CrmListErrorState = () => {
    return (
        <I18n
            translatable={{ key: "si.crm-lists.error.state.message" }}
            element={StyledErrorContainer}
        />
    );
};

export default CrmListErrorState;
